<script>
import baseMixin from '@/mixins/baseMixin'
import BookingListTabKey from '@/shared/constants/booking/BookingListTabKey'
import SearchBookings from '@/components/booking/bookingList/search-bookings.vue'
import FilterBookings from '@/components/booking/bookingList/filter-bookings.vue'
import DateFilter from '@/components/booking/bookingList/date-filter.vue'
import TheClientFilter from '@/components/layout/the-client-filter.vue'
import BookingViewToggleOption from '@/components/booking/bookingList/booking-view-toggle-option.vue'
import ExportOption from '@/components/booking/bookingList/export-option.vue'
import { mapGetters } from 'vuex'
import featureFlagMixin from '@/mixins/featureFlagMixin'

export default {
  name: 'TopFilterBar',
  components: {
    SearchBookings,
    FilterBookings,
    DateFilter,
    TheClientFilter,
    BookingViewToggleOption,
    ExportOption,
  },
  mixins: [baseMixin, featureFlagMixin],
  props: {
    modelValue: { type: String, default: '' },
    currentTabName: { type: String, required: true },
    selectedCount: { type: Number, default: 0 },
    educators: { type: Array, default: () => [] },
    classifications: { type: Array, default: () => [] },
    certifications: { type: Array, default: () => [] },
    grades: { type: Array, default: () => [] },
    replacing: { type: Array, default: () => [] },
  },
  emits: [
    'date-filter',
    'export',
    'export-selected',
    'filter-change',
    'update:selectedClientIds',
  ],
  data() {
    return {
      showDayByDayBlock: true,
      BookingListTabKey,
    }
  },
  computed: {
    ...mapGetters({
      clientList: 'auth/getAllClients',
      selectedClientIds: 'client/getSelectedClients',
      locations: 'auth/getAllLocations',
    }),
  },
  methods: {
    toggleFilter() {
      if (
        this.$refs.filterBookings &&
        this.$refs.filterBookings.toggleAllFilter
      ) {
        this.$refs.filterBookings.toggleAllFilter()
      }
    },
    toggleDayByDayBlock(e) {
      this.showDayByDayBlock = e === 1
      this.$emit('active-tab', e)
    },
    applySelection(clientIds) {
      this.$emit('update:selectedClientIds', clientIds)
    },
    applyFilter(filters) {
      this.$emit('filter-change', filters)
    },
    onDateFilter(dates) {
      this.$emit('date-filter', dates)
    },
  },
}
</script>

<template>
  <div
    class="top-filter-bar"
    :class="[
      isMobile && currentTabName !== BookingListTabKey.approvalRequired
        ? 'mobile-top-filter-bar'
        : '',
    ]"
  >
    <!-- Search bar -->
    <SearchBookings
      ref="searchBookings"
      :model-value="modelValue"
      @search="$emit('search', $event)"
    />

    <!-- filter button -->
    <FilterBookings
      v-if="currentTabName !== BookingListTabKey.approvalRequired"
      ref="filterBookings"
      :current-tab-name="currentTabName"
      :locations="locations"
      :educators="educators"
      :classifications="classifications"
      :certifications="certifications"
      :grades="grades"
      :replacing="replacing"
      @filter-change="applyFilter"
    />

    <!-- date filter -->
    <DateFilter
      v-if="!isMobile && currentTabName !== BookingListTabKey.approvalRequired"
      ref="dateFilter"
      @filter-dates="onDateFilter"
    />

    <!-- client filter -->
    <TheClientFilter
      v-if="!isMobile && clientList.length > 1"
      ref="clientFilterOption"
      @update="applySelection"
    />

    <!-- day by day and block filter -->
    <BookingViewToggleOption
      v-if="!isMobile && currentTabName !== BookingListTabKey.approvalRequired"
      ref="bookingViewToggleOption"
      :show-day-by-day-block="showDayByDayBlock"
      @toggle="toggleDayByDayBlock"
    />

    <!-- export button -->
    <ExportOption
      v-if="!isMobile && selfServiceFeatureFlags.enableBookingExport"
      ref="exportOption"
      :selected-count="selectedCount"
      @export="$emit('export')"
      @export-selected="$emit('export-selected')"
    />

    <div v-if="isMobile" class="right-dots" @click.stop="toggleFilter">
      <v-icon small>mdi-dots-vertical</v-icon>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-top-filter-bar.scss';
</style>
